export const flowPayTheFeesZH = {
  flowPayTheFees1: '缴费',
  flowPayTheFees2: '早鸟优惠倒计时',
  flowPayTheFees3: '余量紧张',
  flowPayTheFees4: '售罄',
  flowPayTheFees5: '查看详情',
  flowPayTheFees6: '优惠券',
  flowPayTheFees7: '张可用',
  flowPayTheFees8: '兑换优惠券',
  flowPayTheFees9: '您选择的优惠券金额大于商品金额，确认使用后该优惠券将不可再次使用',
  flowPayTheFees10: '应付总额',
  flowPayTheFees11: '立即支付',
  flowPayTheFees12: '费用说明',
  flowPayTheFees13: '选择优惠券',
  flowPayTheFees14: '元',
  flowPayTheFees15: '请输入优惠券兑换码',
  flowPayTheFees16: '兑换成功',
  flowPayTheFees17: '天',
  flowPayTheFees18: '时',
  flowPayTheFees19: '分',
  flowPayTheFees20: '订单详情',
  flowPayTheFees21: '交易状态',
  flowPayTheFees22: '银联支付',
  flowPayTheFees23: '线下支付',
  flowPayTheFees24: '支付宝支付',
  flowPayTheFees25: '微信支付',
  flowPayTheFees26: '实付金额',
  flowPayTheFees27: '实付总额',
  flowPayTheFees28: '提交申请',
  flowPayTheFees29: '此订单已经超过可自主退款时效，如需退款请联系校园合作老师或者活动官方邮箱',
  flowPayTheFees30: '订单确认',
  flowPayTheFees31: '订单信息',
  flowPayTheFees32: '优惠金额',
  flowPayTheFees33: '应付总额',
  flowPayTheFees34: '确定支付',
  flowPayTheFees35: '请使用支付宝扫一扫',
  flowPayTheFees36: '请使用微信扫一扫',
  flowPayTheFees37: '请使用银联App扫一扫',
  flowPayTheFees38: '请用手机打开微信或支付宝扫码支付',
  flowPayTheFees39: '是否已完成支付？',
  flowPayTheFees40: '未支付',
  flowPayTheFees41: '已支付',
  flowPayTheFees42: '缴费',
  flowPayTheFees43: '支付金额',
  flowPayTheFees44: '退款金额',
  flowPayTheFees45: '退款理由',
  flowPayTheFees46: '退款时间',
  flowPayTheFees47: '实际到账时间取决于银行',
  flowPayTheFees48: '报名人信息',
  flowPayTheFees49: '姓名',
  flowPayTheFees50: '我已阅读并同意',
  flowPayTheFees51: '《免责声明》',
  flowPayTheFees52: '《项目协议书》',
  flowPayTheFees53: '早鸟优惠',
  flowPayTheFees54: '温馨提示',
  flowPayTheFees55: '签署《项目协议书》',
  flowPayTheFees56: '合计',
  flowPayTheFees57: '重新缴费',
  flowPayTheFees58: '申请发票',
  flowPayTheFees59: '查看发票',
  flowPayTheFees60: '我的优惠券',
  flowPayTheFees61: '选择费项页面',
  flowPayTheFees62: '请确认是否同意《免责声明》！',
  flowPayTheFees63: '请选择要缴纳的费用',
  flowPayTheFees64: '支付中',
  flowPayTheFees65: '退款中',
  flowPayTheFees66: '已退款',
  flowPayTheFees67: '扫描二维码支付',
  flowPayTheFees68: '小时后方可开始练习哦！',
  flowPayTheFees70: '确认支付',
  flowPayTheFees71: '平台暂不支持微信小程序支付，我们正在积极修复，你可先复制链接并前往网页完成支付哦',
  flowPayTheFees72: '复制链接',
  flowPayTheFees73: '秒',
  flowPayTheFees74: '微信扫一扫',
  flowPayTheFees75: '取消订单',
  flowPayTheFees76: '是否确认取消订单？',
  flowPayTheFees77: '提示',
  flowPayTheFees78: '确定',
  flowPayTheFees79: '取消',
  flowPayTheFees80: '查看图片',
  flowPayTheFees81: '服务条款确认',
  flowPayTheFees82: '同意并支付',
  flowPayTheFees83: '天',
  flowPayTheFees84: '请选择商品后再使用优惠券～',
  flowPayTheFees85: '以下优惠券不适用于当前商品',
  flowPayTheFees86: '今日',
  flowPayTheFees87: '过期',
  flowPayTheFees88: '你暂时还没有优惠券哦～',
  flowPayTheFees89: '请选择'
}
export const flowPayTheFeesEN = {
  flowPayTheFees1: 'Payment',
  flowPayTheFees2: 'Early Bird Discount Ends in',
  flowPayTheFees3: 'Low stocks',
  flowPayTheFees4: 'Sold out',
  flowPayTheFees5: 'View Details',
  flowPayTheFees6: 'Coupon',
  flowPayTheFees7: ' coupons available',
  flowPayTheFees8: 'Redeem your coupon',
  flowPayTheFees9: 'The amount of the coupon you selected is greater than the amount of the product. After confirmation of use, the coupon can not be used again',
  flowPayTheFees10: 'Total payment amount',
  flowPayTheFees11: 'Pay Now',
  flowPayTheFees12: 'Fee Description',
  flowPayTheFees13: 'Select Coupon',
  flowPayTheFees14: 'RMB',
  flowPayTheFees15: 'Enter the coupon redeem code',
  flowPayTheFees16: 'Redeemed Successfully',
  flowPayTheFees17: 'days',
  flowPayTheFees18: 'hours',
  flowPayTheFees19: 'minutes',
  flowPayTheFees20: 'Order Details',
  flowPayTheFees21: 'Transaction Status',
  flowPayTheFees22: 'UnionPay Payment',
  flowPayTheFees23: 'Offline Payment',
  flowPayTheFees24: 'Alipay payment',
  flowPayTheFees25: 'WeChat Pay',
  flowPayTheFees26: 'Actual Payment',
  flowPayTheFees27: 'Total payment amount',
  flowPayTheFees28: 'Submit application',
  flowPayTheFees29: 'This order has exceeded the time limit for self-refund, if you need a refund, please contact the campus partner teacher or the official email of the activity',
  flowPayTheFees30: 'Order Confirmation',
  flowPayTheFees31: 'Order Information',
  flowPayTheFees32: 'Discount Amount',
  flowPayTheFees33: 'Total payment amount',
  flowPayTheFees34: 'Confirm Payment',
  flowPayTheFees35: 'Please use Alipay to scan the QR code to pay',
  flowPayTheFees36: 'Please use WeChat to scan the QR code to pay',
  flowPayTheFees37: 'Please use the UnionPay App to scan the QR code to pay',
  flowPayTheFees38: 'Please use your mobile phone to open WeChat or Alipay to scan the code to pay',
  flowPayTheFees39: 'Have you already made the payment?',
  flowPayTheFees40: 'Unpaid',
  flowPayTheFees41: 'Paid',
  flowPayTheFees42: 'Pay the fee for ',
  flowPayTheFees43: 'Payment amount',
  flowPayTheFees44: 'Refund amount',
  flowPayTheFees45: 'Reasons for refund',
  flowPayTheFees46: 'Refund time',
  flowPayTheFees47: 'The actual arrival time depends on the bank',
  flowPayTheFees48: 'Registration information',
  flowPayTheFees49: 'Name',
  flowPayTheFees50: 'I have read and agreed',
  flowPayTheFees51: '《Exemption Agreement》',
  flowPayTheFees52: '《Project Agreement》',
  flowPayTheFees53: 'Early Bird discount',
  flowPayTheFees54: 'Reminder',
  flowPayTheFees55: 'Sign the 《Project Agreement》',
  flowPayTheFees56: 'Total',
  flowPayTheFees57: 'Re-payment',
  flowPayTheFees58: 'Apply for invoice',
  flowPayTheFees59: 'View invoices',
  flowPayTheFees60: 'My coupon',
  flowPayTheFees61: 'Select the fee item page',
  flowPayTheFees62: 'Please confirm if you agree to the Exemption Agreement!',
  flowPayTheFees63: 'Please select the fee to be paid',
  flowPayTheFees64: 'Unpaid',
  flowPayTheFees65: 'Refund in progress',
  flowPayTheFees66: 'Refunded',
  flowPayTheFees67: 'Scan the QR code for payment ',
  flowPayTheFees68: 'hours before you can start practicing!',
  flowPayTheFees70: 'Confirm payment',
  flowPayTheFees71: 'The platform does not support WeChat mini app payment for now. We are actively fixing it. You can copy the link and go to the webpage to complete the payment first!',
  flowPayTheFees72: 'Copy the link',
  flowPayTheFees73: 'seconds',
  flowPayTheFees74: 'WeChat Scan',
  flowPayTheFees75: 'Cancel Order',
  flowPayTheFees76: 'Confirmation of order cancellation？',
  flowPayTheFees77: 'Tips',
  flowPayTheFees78: 'Confirm',
  flowPayTheFees79: 'Cancel',
  flowPayTheFees80: 'View Picture',
  flowPayTheFees81: 'Confirmation of Service Terms',
  flowPayTheFees82: 'Agree and Pay',
  flowPayTheFees83: 'day',
  flowPayTheFees84: 'Please select items before applying a coupon.',
  flowPayTheFees85: 'The following coupons are valid for your current items!',
  flowPayTheFees86: 'Expires at ',
  flowPayTheFees87: ' today',
  flowPayTheFees88: 'You don\'t have any coupons yet!',
  flowPayTheFees89: 'Select'
}



// WEBPACK FOOTER //
// ./src/i18n/langs/flow/payTheFees.js